import { monthAbbr, twoDigitTimeValue } from "./DateUtils";

type NumberOrNothingType = number | undefined | null

// Convert to a money string
export function ToMoneyStr(val:any): string | undefined {
    if (null === val || undefined === val)
        return;
        
    return `$${val.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})}`;
}

export function ToAccountingMoneyStr(val: NumberOrNothingType): string | undefined {
    if (null === val || undefined === val)
        return;

    if (val < 0)
        return `(${ToMoneyStr(-1*val)})`;
    return ToMoneyStr(val);
}

// Convert to a percentage string
export function ToPercentStr(val: NumberOrNothingType): string | undefined {
    if (null === val || undefined === val)
        return;
    return ToTrimmedDecimalStr(val) + "%";
}

export function ToTrimmedDecimalStr(val: NumberOrNothingType): string | undefined {
    if (null === val || undefined === val)
        return;

    let valStr = _ToTrimmedDecimalStr(val);

    // Is there a decimal?
    const decimalChar = localeDecimalSeparator();
    const decimalPos = valStr.indexOf(decimalChar);
    if (-1 === decimalPos)
        return valStr;

    // Trim the zeros and/or decimal as needed
    while(true)
    {
        const len = valStr.length;
        const lastChar = valStr.charAt(len-1);
        if ("0" !== lastChar && decimalChar !== lastChar)
            return valStr;

        valStr = valStr.slice(0, -1);
        if (decimalChar === lastChar)
            return valStr;
    }
}

// Trim the decimal value on a number and make pretty
function _ToTrimmedDecimalStr(val: number): string{
    const absVal = Math.abs(val);
    if (absVal >= 100)
    {
        const prettyVal = ToPrettyNumber(val);
        const decimalPos = prettyVal.indexOf(localeDecimalSeparator());
        if (-1 === decimalPos)
            return prettyVal;
        return prettyVal.substring(0, decimalPos);
    }

    if (absVal > 10)
        return `${val.toFixed(1)}`;
    if(absVal > 1)
        return `${val.toFixed(2)}`;
    return `${val.toFixed(3)}`;
}


export function ToPrettyNumber(val: NumberOrNothingType): string{
    if (null === val || undefined === val)
        return "";

    const absVal = Math.abs(val);
    if (absVal < 1)
        return val.toLocaleString(undefined, {maximumFractionDigits: 3});
    return val.toLocaleString(undefined, {maximumFractionDigits: 2});
}

// What is the decimal seperator for this locale?
function localeDecimalSeparator() {
    return (1.1).toLocaleString().substring(1, 2);
}

// Get a timestamp string we can use as part of a filename
export function ToFilenameTimestamp(date?:Date)
{
    if (!date)
        date = new Date();

    return `${date.getFullYear()}_${monthAbbr(date)}_${date.getDate()}_${twoDigitTimeValue(date.getHours())}_${twoDigitTimeValue(date.getMinutes())}_${twoDigitTimeValue(date.getSeconds())}`;
}
// Get a timestamp string we can use as part of a report header
export function ToReportTimestamp(date?:Date)
{
    if (!date)
        date = new Date();
    return `${monthAbbr(date)} ${date.getDate()} ${date.getFullYear()} ${twoDigitTimeValue(date.getHours())}:${twoDigitTimeValue(date.getMinutes())}:${twoDigitTimeValue(date.getSeconds())}`;
}
